module.exports = __webpack_public_path__ + "img/water_device.41ebb860.svg";